import React from 'react';
import { Clock } from 'lucide-react';

// Card for upcoming (not-yet-launched) products. No price-to-cart actions.
const UpcomingProductCard = ({ product }) => {
  return (
    <div
      data-testid={`upcoming-product-${product.id}`}
      className="group relative overflow-hidden rounded-3xl crunch-shadow bg-white flex flex-col transition-transform hover:-translate-y-1"
    >
      <div className="relative overflow-hidden aspect-[4/5]" style={{ background: product.bg }}>
        {product.image ? (
          <img
            src={product.image}
            alt={`${product.line} — ${product.flavor}`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center p-6 text-center">
            <div className="text-[10px] font-bold uppercase tracking-widest opacity-60">Packshot</div>
            <div className="font-display text-3xl md:text-4xl uppercase leading-none mt-2" style={{ color: product.color }}>
              {product.line}
            </div>
            <div className="mt-2 inline-flex items-center gap-1.5 bg-[#1a1a1a] text-[#FFF4E6] px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest">
              {product.flavor}
            </div>
            <div className="text-[10px] font-brico opacity-60 mt-3">Design dropping soon</div>
          </div>
        )}

        <div className="absolute top-3 left-3 inline-flex items-center gap-1 bg-[#1a1a1a] text-[#FFD84D] px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest">
          <Clock size={10} /> Coming soon
        </div>
      </div>

      <div className="p-4 border-t-2 border-[#1a1a1a]">
        <div className="text-[10px] font-bold uppercase tracking-widest opacity-60">{product.line}</div>
        <div className="font-display text-xl uppercase mt-0.5" style={{ color: product.color }}>{product.flavor}</div>
        <div className="mt-1 flex items-center justify-between font-brico text-sm">
          <span className="opacity-70">{product.weight} pack</span>
          <span className="font-bold">₹{product.price}</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1">
          {product.tags?.map((t) => (
            <span key={t} className="text-[9px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full border border-[#1a1a1a]/20 opacity-70">
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UpcomingProductCard;
